<template>
  <section>
    <div class="row my-4">
      <div class="col-md-12 text-center">
        <i class="fal fa-check-circle -status-accepted fa-4x" v-if="success"></i>
        <div class="my-4">
          {{ text }}
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'

  export default {
    data () {
      return {
        text: '',
        success: false
      }
    },
    created () {
      const url = 'line/login-professional'
      const queryParams = this.$route.query
      axios.get(url, {params: queryParams})
        .then(res => {
          const response = res.data
          console.log('DEBUG', response)
          if (response.error) {
            this.text = 'การเชื่อมต่อไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่ค่ะ'
          } else {
            this.success = true
            this.text = 'สำเร็จ คุณสามารถปิดหน้านี้เพื่อทำรายการอื่น ๆ ต่อได้เลยค่ะ'
          }
        })
        .catch(error => {
          console.log('DEBUG', error)
          this.text = 'การเชื่อมต่อไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อเจ้าหน้าที่ค่ะ'
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/information/LineProfessionalLoginCallback.vue